import ACTIONS from "../constants/actions";

const {
  DAILY_REPORT_LIST,
  DAILY_REPORT_LIST_SUCCESS,
  DAILY_REPORT_LIST_FAIL,
  DAILY_REPORT_SETTING_BY_USER,
  DAILY_REPORT_SETTING_BY_USER_SUCCESS,
  DAILY_REPORT_SETTING_BY_USER_FAIL,
  CREATE_DAILY_REPORT,
  CREATE_DAILY_REPORT_SUCCESS,
  CREATE_DAILY_REPORT_FAIL,
  DAILY_REPORT_TEMPLATE,
  DAILY_REPORT_TEMPLATE_SUCCESS,
  DAILY_REPORT_TEMPLATE_FAIL,
  ALL_DAILY_REPORT_LIST,
  ALL_DAILY_REPORT_LIST_SUCCESS,
  ALL_DAILY_REPORT_LIST_FAIL,
  SHOULD_FETCH_DATA_DAILY_TEMPLATE,
} = ACTIONS;

const initialState = {
  isLoadingDailyReport: false,
  isLoadingCreateDailyReport: false,
  isLoadingDailyReportTemplate: false,
  isLoadingAllDailyReportTemplate: false,
  allDailyReportTemplate: [],
  dailyReportList: [],
  dailyReportByUser: { template: { name: "", id: "" } },
  dailyReportTemplate: { totalPages: 0 },
  shouldFetchData: null,
};

const dailyReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case DAILY_REPORT_LIST:
      return {
        ...state,
        isLoadingDailyReport: true,
      };
    case DAILY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        isLoadingDailyReport: false,
        dailyReportList: action.payload,
      };
    case DAILY_REPORT_LIST_FAIL:
      return {
        ...state,
        isLoadingDailyReport: false,
      };
    case DAILY_REPORT_SETTING_BY_USER:
      return {
        ...state,
        isLoadingDailyReport: true,
      };
    case DAILY_REPORT_SETTING_BY_USER_SUCCESS:
      return {
        ...state,
        isLoadingDailyReport: false,
        dailyReportByUser: action.payload,
      };
    case DAILY_REPORT_SETTING_BY_USER_FAIL:
      return {
        ...state,
        isLoadingDailyReport: false,
      };
    case CREATE_DAILY_REPORT:
      return {
        ...state,
        isLoadingCreateDailyReport: true,
      };
    case CREATE_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        isLoadingCreateDailyReport: false,
      };
    case CREATE_DAILY_REPORT_FAIL:
      return {
        ...state,
        isLoadingCreateDailyReport: false,
      };
    case DAILY_REPORT_TEMPLATE:
      return {
        ...state,
        isLoadingDailyReportTemplate: true,
      };
    case DAILY_REPORT_TEMPLATE_SUCCESS:
      return {
        ...state,
        isLoadingDailyReportTemplate: false,
        dailyReportTemplate: action.payload,
      };
    case DAILY_REPORT_TEMPLATE_FAIL:
      return {
        ...state,
        isLoadingDailyReportTemplate: false,
      };
    case ALL_DAILY_REPORT_LIST:
      return {
        ...state,
        isLoadingDailyReportTemplate: true,
      };
    case ALL_DAILY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        isLoadingAllDailyReportTemplate: false,
        allDailyReportTemplate: action.payload,
      };
    case ALL_DAILY_REPORT_LIST_FAIL:
      return {
        ...state,
        isLoadingAllDailyReportTemplate: false,
      };
    case SHOULD_FETCH_DATA_DAILY_TEMPLATE:
      return {
        ...state,
        shouldFetchData: new Date().getTime(),
      };
    default:
      return state;
  }
};
export default dailyReportReducer;
